export default "__VITE_ASSET__BYMdMRbC__"